import { useEffect } from "preact/hooks";
import { useSignal } from "@preact/signals";

const useDebounce = <T>(value: T, delay = 500) => {
    const debounced = useSignal(value);

    useEffect(() => {
        const handler = window.setTimeout(() => {
            debounced.value = value;
        }, delay);

        return () => {
            window.clearTimeout(handler);
        };
    }, [value, delay, debounced]);

    return debounced;
};

export default useDebounce;
